module.exports = require('frontend/components/abstract').extend
  template: require('./index.pug')

  components:
    'image-group': require('./components/image_group')

  data: ->
    loaded:           false
    closed:           false
    animating:        false
    cssClassesFirst:  ''
    cssClassesSecond: ''

  computed:

    windowWidth: ->
      @.$store.state.window.height

  methods:

    loadData: ->
      @.$store.dispatch('partners/load')
      @.$set @, 'loaded', true

    onImageLoaded: ->
      @.$emit 'boundingUpdated'

    onClickToggle: ->
      @.$set @, 'closed', @closed == false
      @.$store.dispatch('cookie/set', { module: 'partners-slider', name: 'closed', value: @closed == true })

    loadClosedState: ->
      @.$store.dispatch('cookie/load', { module: 'partners-slider', name: 'closed' })
      .then (value) => @.$set @, 'closed', value == true
      .done()

  watch:

    windowWidth: ->
      @loadData() unless @loaded

  created: ->
    @loadClosedState()

  mounted: ->
    if @.$store.state.window.height > 650
      @loadData()
      @.$set @, 'animating', true

    @.$nextTick =>
      @.$set @, 'cssClassesFirst',  'animate animate-first-time'
      @.$set @, 'cssClassesSecond', 'animate'

      setTimeout =>
        @.$set @, 'cssClassesFirst',  'animate'
      , 30000


// WEBPACK FOOTER //
// ./assets/js/frontend/components/partners_slider/index.coffee